import React, { useState, useEffect } from "react";
import { VideoButton } from "../../utils/SvgComponents";
import CustomCard from "./card/Card";
import { useNavigate } from "react-router-dom";

const GalleryCardPC = ({
	color = "white",
	videoIconColor,
	paramid,
	data,
	title,
	HandleOnclick,
	cardBgImage,
	slug,
	username,
id,
	video = false,
	photos = false
}) => {

	const [showAnimation, setShowAnimation] = useState(false);
	const [showCard, setShowCard] = useState(false);
			const [isImageLoaded, setIsImageLoaded] = useState(true);
	const page = localStorage.getItem("photos_page");

	const hasVisited = localStorage.getItem("hasVisitedPhotosPage");

	useEffect(() => {
		const timer = window.location.pathname === `/photos/${paramid}` && setTimeout(() => {
			const hasVisited = localStorage.getItem("hasVisitedPhotosPage");
	  
			if (!hasVisited) {
			  setShowAnimation(true);
			  localStorage.setItem("hasVisitedPhotosPage", "true");
			}
	  
			
		}, 3000); // Delay execution by 2 seconds
		if (page) {
		setShowCard(true);
		}
		return () => clearTimeout(timer);
	}, [page]);
	

	  
return (
  <div className="w-full">
    <div className="pageOne-Card rounded-xl overflow-hidden relative whiteripple">

      {/* CONDITIONAL LOGIC */}
      {!photos ? (
        /* ===========================
           PHOTOS = FALSE → onClick()
        ============================ */
        <div onClick={HandleOnclick} className="block relative cursor-pointer">

          <img
            src={`${data?.cardBgImage}`}
            alt="card-image"
            onLoad={() => setIsImageLoaded(false)}
            className={`relative h-[180px] w-full object-cover transition-all duration-500 ${
              isImageLoaded ? "blur-lg scale-105" : "blur-0 scale-100"
            }`}
          />

          <div
            className="bg-black/55 absolute mx-auto py-[7px] bottom-0 left-0 flex justify-center items-center w-full"
            style={{
              backgroundColor:
                color === "white"
                  ? "rgba(0, 0, 0, 0.548)"
                  : "rgba(255, 255, 255, 0.6)"
            }}
          >
            <p className={`text-${color} my-0`}>{title}</p>
          </div>

          {video && (
            <div className="video-play-button absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-black/55 rounded-[50%]">
              <VideoButton
                fill={videoIconColor ? videoIconColor : color}
                width="50"
                height="50"
              />
            </div>
          )}
        </div>
      ) : (
        /* ===========================
           PHOTOS = TRUE → OPEN NEW TAB
        ============================ */
        <a
          href={`/${username}/GalleryImage/${id}/${slug}`}
          target="_blank"
          rel="noopener noreferrer"
          className="block relative"
        >
          <img
            src={`${data?.cardBgImage}`}
            alt="card-image"
            onLoad={() => {
              setTimeout(() => setIsImageLoaded(false), 200);
            }}
            className={`relative h-[180px] w-full object-cover transition-all duration-500 ${
              isImageLoaded ? "blur-lg scale-105" : "blur-0 scale-100"
            }`}
          />

          <div className="absolute top-0 left-0 p-[20px] w-full h-full bg-black/40">
            <div
              style={{
                position: "absolute",
                top: "12%",
                bottom: "12%",
                left: "5%",
                right: "5%",
                zIndex: 3
              }}
            >
              {["top", "bottom", "left", "right"].map((side) => (
                <div
                  key={side}
                  className={`${page ? `${side}-border` : ""} ${
                    hasVisited ? `${side}-border-active` : ""
                  }`}
                ></div>
              ))}
            </div>
          </div>

          <div className="absolute mx-auto py-[7px] bottom-12 left-0 flex justify-center items-center w-full">
            <p className="text-center text-white font-medium text-[21px] z-[1] pointer-events-none">
              {data.title}
            </p>
          </div>
        </a>
      )}
    </div>
  </div>
);


};

export default GalleryCardPC;
